var LoadingButton = require("components/utility/LoadingButton");
var ErrorDisplay = require("components/utility/ErrorDisplay");
var WhooosReadingServices = require("lib/web/WhooosReadingServices");
var CurrentUser = require("lib/account/CurrentUser");

class RosterUploadInitial extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			loading: false
		};
	}

	submitUpload(e) {
		$wr.nope(e)
		this.refs.errors.reset();

		var ext = this.refs.file.value.split(".").pop().toLowerCase();
		var validExtensions = ["csv", "xls", "xlsx"];

		if (validExtensions.indexOf(ext) == -1) {
			this.refs.errors.setError("Please upload a CSV, XLS, or XLSX spreadsheet file.");

		} else {
			this.setState({ loading: true });

			var file = this.refs.file.files[0];

			var formData = new FormData();
			formData.append("file", file);

			CurrentUser.api().postRostersParse(null, { form: formData }, $wr.apiHandler(function(response) {
				this.props.updateRosterData(response.roster, function() {
					this.props.nextStage();					
				}.bind(this));

			}.bind(this)));
		}
	}

	onTaskUpdate() {
		this.forceUpdate();
	}

	componentDidMount() {
		$(document).on('start_task', this.onTaskUpdate);
		$(document).on('task_finished_loading', this.onTaskUpdate);
	}

	componentWillUnmount() {
		$(document).off('start_task', this.onTaskUpdate);
		$(document).off('task_finished_loading', this.onTaskUpdate);
	}

	render() {
		if (window.pendingTaskRunning) { 
			var loadingMessage = (
				<p className="loadingText">
					Your students are still uploading, they will be added to your roster shortly.
				</p>
			);
			var disabledClassName = "disabled"
		}

		var rosterImageURL = WhooosReadingServices.FileStation.url("/screenshots/roster-1.png");

		return (
			<div>
				<form encType="multipart/form-data" method="post" onSubmit={ this.submitUpload } >
					<ErrorDisplay ref="errors" />
					<input type="text" style={{ display: 'none' }} name="process" defaultValue={ this.props.process }/>
					<input type="text" style={{ display: 'none' }} name="stage" defaultValue={ this.props.stage }/>
					<div className="uploadPair clearfix">
						{ loadingMessage }
						<input type="file" name="file" ref="file" className={ disabledClassName + " btn btn-default uploadField" } />
						<LoadingButton className={ disabledClassName + " btn buttonSuccess uploadSubmit" } loading={ this.state.loading } text="Upload" />
					</div>
				</form>
				<div className="explanation">
					<div className="textExplanation">
						The student roster needs to be either a CSV (ending in .csv) or Microsoft Excel
						file (ending in .xlsx or .xls) with headers for these columns:
						<ol>
							<li>First Name</li>
							<li>Last Name (or Initial)</li>
							<li>Grade Level</li>
							<li>Teacher Name</li>
							<li>Parent Email (optional)</li>
							<li>Username (optional)</li>
							<li>Password (optional)</li>
						</ol>
					</div>
					<div className="exampleTableSection">
						<img height={ 169 } src={ rosterImageURL } />
						<span className="smallText formatText">(An example of a correctly formatted student roster.)</span>
					</div>
				</div>
			</div>
		)
	}
};

RosterUploadInitial.propTypes = StrictPropTypes({
	nextStage: PropTypes.func.isRequired,
	updateRosterData: PropTypes.func.isRequired,
	roster: PropTypes.object
});

module.exports = RosterUploadInitial;


// WEBPACK FOOTER //
// ./modules/components/org/roster_upload/RosterUploadInitial.js